module.exports = __webpack_public_path__ + "img/not-authorized-dark.31855703.svg";